

export function dispatchEvent(eventName, detail) {
	window.dispatchEvent(new CustomEvent(eventName, { detail }))
}